module.exports = require("tiny-glob");